<template>
  <stats-card v-loading="loading" title="Total a ser recebido" type="primary" class="mb-0" :sub-title="`${numberToBRL}`" icon="ni ni-money-coins">
  </stats-card>
</template>

<script>
import { formatNumberToBRL } from '../../../helpers/formaters'
import { mapState, mapActions } from 'vuex';
export default {
  data(){
    return {
      value: '',
      loading: false
    }
  },
  computed: {
    ...mapState('client',['pendenciesClients']),
    numberToBRL(){
      return formatNumberToBRL(this.pendenciesClients)
    }
  },
  methods: {
    ...mapActions('client',['getPendenciesClients'])
  },
  async mounted() {
    this.loading = true
    await this.getPendenciesClients()
    this.loading = false
    this.value = this.pendenciesClients ? `${this.pendenciesClients}` : '0'
  }
}
</script>

<style scoped>

</style>